﻿<template>
    <div class="cart-summary w-full md:w-5/12 lg:w-4/12">
        <div class="basket-summary border border-form rounded w-full px-8 md:p-4 lg:p-4 flex flex-col">
            <itinerary_breakdown display_open=true></itinerary_breakdown>
            <hr />
            <trip_summary></trip_summary>

            <h2 class="text-heading font-bold text-2xl mb-2">
                {{ is_part_paid() ? 'Deposit received' : is_fully_paid() ? 'Fully paid' : 'Payment unsuccessful' }}
            </h2>
            <p class="text-grey-dark text-sm leading-relaxed">
                <template v-if="is_part_paid()">
                    A partial payment was received but your booking is not yet fully paid. Your booking reference is <strong>#{{ $store.getters.get_Booking?.group_booking_id }}</strong>.
                    To pay your remaining balance please use the button below, or contact us if you have any questions:
                </template>
                <template v-else-if="is_fully_paid()">
                    Thank you for your payment. Your booking reference is <strong>#{{ $store.getters.get_Booking?.group_booking_id }}</strong> - please quote this if you need to contact us:
                </template>
                <template v-else>
                    Your payment was unsuccessful or cancelled. You have not been charged. Your booking reference is <strong>#{{ $store.getters.get_Booking?.group_booking_id }}</strong> - please quote this if you contact us.
                    To complete your booking please try again, or contact us:
                </template>
            </p>
            <div class="w-full rounded-xl px-4 flex flex-col text-left text-sm">
                <a v-if="GetBrand() == 'HEX'" href="mailto:info@highlandexplorertours.com" class="text-action font-semibold">info@highlandexplorertours.com</a>
                <a v-else-if="GetBrand() == 'HAG'" href="mailto:info@haggisadventures.com" class="text-action font-semibold">info@haggisadventures.com</a>
                <a v-else-if="GetBrand() == 'AAT'" href="https://www.aatkings.com/contact-us" class="text-action font-semibold" target="_blank" rel="noopener noreferrer">https://www.aatkings.com/contact-us</a>
            </div>

            <div class="py-8" v-if="has_balance_outstanding()">
                <h6 class="title text-2xl text-heading font-bold">
                    {{ is_part_paid() ? 'Remaining Balance Due' : 'Payment Unsuccessful' }}
                </h6>
                <p class="balance text-black text-2xl text-action font-bold mb-0">{{get_balance_outstanding_formatted()}} <span class="font-normal text-lg">{{get_Currency()}}</span> <small class="font-normal text-sm">includes all taxes.</small></p>
                <p class="balance-remaning text-sm mt-2 mb-0">Balance of <span class="font-bold">{{get_balance_outstanding_formatted()}} </span> due by {{Balance_Due_Date()}}</p>
                <button v-if="is_part_paid()" type="button" class="button button-pink-book full mt-10 print:hidden" v-on:click="redirect_to_paymentpage(get_balance_outstanding())">
                    Pay remaining balance
                </button>
                <button v-else-if="is_not_paid()" type="button" class="button button-pink-book full mt-10 print:hidden" v-on:click="redirect_to_paymentpage(get_payment_amount())">
                    Try again
                </button>
            </div>
            <div v-else>
                <h6 class="title text-base text-heading font-bold">Total Price Paid</h6>
                <p id="totalPaidPrice" class="balance text-black text-2xl text-action font-bold mb-0">{{get_Total_Price()}} <span class="font-normal text-lg">{{get_Currency()}}</span> <small class="font-normal text-sm">includes all taxes.</small></p>
            </div>

        </div>
    </div>
</template>
<script lang="ts" src="./summary.ts"></script>
